import { render } from "./SignupFormView.vue?vue&type=template&id=b1c1f0c8&scoped=true"
import script from "./SignupFormView.vue?vue&type=script&lang=js"
export * from "./SignupFormView.vue?vue&type=script&lang=js"

import "./SignupFormView.vue?vue&type=style&index=0&id=b1c1f0c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c1f0c8"]])

export default __exports__